module.exports = __webpack_public_path__ + "a5999d2b0278467dc55883b77c2f9a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-nickel-brushed.png
// module id = +NM1
// module chunks = 5